import ReactNativeFile from "@repo/graphql/client/file";
import { Image } from "../../ui/image";
import TileChrome from "./TileChrome";

export default function ImageTile({
  file,
  index,
  total,
  onRemove,
  onMoveLeft,
  onMoveRight,
}: {
  file: ReactNativeFile;
  index: number;
  total: number;
  onRemove: () => void;
  onMoveLeft: () => void;
  onMoveRight: () => void;
}) {
  return (
    <TileChrome
      index={index}
      total={total}
      onRemove={onRemove}
      onMoveLeft={onMoveLeft}
      onMoveRight={onMoveRight}
    >
      <Image
        source={{ uri: file.uri }}
        alt={file.name}
        size="none"
        className="w-full h-full"
        contentFit="cover"
      />
    </TileChrome>
  );
}
